var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon';
import './Progress.styles.scss';
var Progress = function (_a) {
    var _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.infinite, infinite = _c === void 0 ? false : _c, _d = _a.percentNumber, percentNumber = _d === void 0 ? 0 : _d, _e = _a.showPercentNumber, showPercentNumber = _e === void 0 ? true : _e;
    var getVariant = function () {
        if (error) {
            return {
                variant: 'danger',
            };
        }
        if (percentNumber >= 100) {
            return {
                variant: 'success',
            };
        }
        return {
            variant: 'primary',
        };
    };
    var variant = getVariant().variant;
    var rangeLimit = function () {
        if (percentNumber < 0) {
            return '0%';
        }
        return "".concat(percentNumber, "%");
    };
    function getStatus(variant) {
        var status = {
            danger: function () {
                return (_jsxs(_Fragment, { children: [_jsx(Icon, { option: "CancelCircle", variant: "danger", size: "xs" }), ' ', _jsx("span", { children: "Erro" })] }));
            },
            primary: function () {
                return _jsx(_Fragment, { children: rangeLimit() });
            },
            success: function () {
                return (_jsxs(_Fragment, { children: [_jsx(Icon, { option: "CheckCircle", variant: "success", size: "xs" }), ' ', _jsx("span", { children: "Conclu\u00EDdo" })] }));
            },
        };
        return status[variant]();
    }
    var shouldShowLabel = showPercentNumber || percentNumber >= 100 || error;
    return (_jsxs("div", __assign({ className: "hefesto-progress" }, { children: [_jsx("div", __assign({ className: "hefesto-progress__bar" }, { children: _jsx("div", { className: "hefesto-progress__bar__value hefesto-progress__bar__value--".concat(variant, " ").concat(infinite ? 'hefesto-progress__bar__value__infinite' : ''), style: { width: "".concat(percentNumber, "%") }, "data-testid": "hefestoProgress__bar__value" }) })), _jsx("span", __assign({ className: "hefesto-progress__label", "data-testid": "hefestoProgress__label" }, { children: shouldShowLabel ? getStatus(variant) : null }))] })));
};
export default Progress;
